const mostPlayedGamesPercent = (games) => {
  return games.map(game => game.percent)
}

export {
  mostPlayedGamesPercent
}
